import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  Upload,
  Icon,
  Radio,
  Checkbox,
  message,
  Divider,
  Modal,
} from 'antd';
import get from 'lodash/get';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { handleUpload, fileUploaderService } from 'shared/utils/FilesUtil';
import { formatMoney } from 'shared/utils/StringUtil';
import { amountInput, reformatNum } from 'shared/utils/FormUtil';
import { permissionService } from 'shared/services';
import { SERVICE_CATEGORIES } from '../../constant/AllBillerDefaultVar';

import MaintenanceForm from '../MaintenanceForm/MaintenanceForm.components';

import allBillerRoute from '../../route';

import text from '../../containers/ServiceCreate/ServiceCreate.page.translation';

import './ServiceForm.style.less';

const { Option } = Select;
const { confirm } = Modal;
const { checkPermission } = permissionService;
const { TextArea } = Input;

const FormMaintenanceRemarks = Form.create()(MaintenanceForm);

class ServiceForm extends Component {
  constructor(props) {
    super(props);
    let bannerImageUrl = [];
    let serviceImageUrl = '';
    let isArchived = false;
    if (props.edit) {
      bannerImageUrl = props.service.banner_abs_url.map((url, index) => ({
        url,
        uid: index,
        name: `bannerImg-${index}`,
      }));
      serviceImageUrl = {
        uid: 1,
        name: 'uploadedIcon',
        url: props.service.icon_abs_url,
      };
      isArchived = get(props.service, 'archived_at', false);
    }

    this.state = {
      serviceIcon: {
        imageUrl: serviceImageUrl,
        loading: false,
      },
      serviceBanner: {
        imageUrl: bannerImageUrl,
        loading: false,
        previewImage: '',
        isPreview: false,
        selectedImage: {},
      },
      searchForm: '',
      isChange: false,
      isArchive: false,
      isMasked: 'yes',
      currentStatus: 'inactive',
      currentArchive: isArchived,
      fromArchive: false,
      remarksInactiveData: this.props.service.deactivation_remarks,
      syncModalVisible: false,
      syncConsent: false,
    };

    this.selectFormRef = React.createRef();
  }

  onValidate = (err, formValues) => {
    if (!err) {
      const {
        serviceIcon,
        serviceBanner,
        currentArchive,
        remarksInactiveData,
      } = this.state;
      const params = {
        name: formValues.serviceName,
        public_name: formValues.publicServiceName,
        universal_keyword: formValues.universalKey,
        category: formValues.serviceCategory,
        icon_abs_url: serviceIcon.imageUrl.url,
        banner_abs_url: serviceBanner.imageUrl.map(item => item.url),
        default_form_id: formValues.form,
        is_active: formValues.status === 'active',
        should_mask_beneficiary_full_name: formValues.maskFullName === 'yes',
        transaction_fee: reformatNum(formValues.transactionFee),
        deactivation_remarks: remarksInactiveData,
      };

      // if (!this.state.syncModalVisible) {
      //   this.setState({ syncModalVisible: true });
      // } else {
      // this.setState({ syncModalVisible: false });
      this.props.onSubmit(
        params,
        currentArchive ? 'archive' : '',
        this.state.syncConsent,
      );
      // }
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const { currentArchive } = this.state;
    const {
      form: { validateFields },
    } = this.props;
    if (currentArchive) {
      this.setState({ isArchive: true });
    } else {
      validateFields(this.onValidate);
    }
  };

  handleCancel = () => {
    this.props.history.goBack();
  };

  handleCancelStatus = () => {
    const { isChange, currentStatus, fromArchive } = this.state;
    const oldStatus = currentStatus === 'active' ? 'inactive' : 'active';
    let fieldKey;
    let fieldValue;
    let newState;

    if (isChange) {
      fieldKey = 'status';
      fieldValue = fromArchive ? 'inactive' : oldStatus;
      newState = { currentStatus: fieldValue };
    }

    if (fieldKey) {
      this.props.form.setFieldsValue({
        [fieldKey]: fieldValue,
      });
    }
    this.props.setRemarksInactive(false);
    this.setState({
      isChange: false,
      isArchive: false,
      ...newState,
    });
  };

  handleChangeStatus = fromArchive => () => {
    const { currentStatus } = this.state;

    this.props.setRemarksInactive(currentStatus === 'inactive' || fromArchive);
    this.setState({
      isChange: currentStatus === 'inactive',
      isArchive: false,
      fromArchive,
    });
  };

  onChangeStatus = e => {
    const fieldKey = e.target.name;
    const currentStatus = e.target.value;
    let newState;

    if (fieldKey === 'archive') {
      newState = { currentArchive: e.target.checked };
    } else if (fieldKey === 'status') {
      newState = { isChange: true, currentStatus };
    }

    this.setState(newState);
  };

  handleSearchAggregator = value => {
    const defaultParam = {
      page_num: 1,
      page_size: 10,
      name: value,
    };
    this.props.getListAggregator(defaultParam);
  };

  handleSearch = type => value => {
    const defaultParam = `page_num=1&page_size=50&name=${value}`;
    if (type === 'form') {
      this.setState({ searchForm: value });
      this.props.getListForm(defaultParam);
    }
  };

  validateFileImage = (info, limitSize) => {
    const {
      intl: { formatMessage },
    } = this.props;
    const { file } = info;
    const isPng = file.type === 'image/png';
    if (!isPng) {
      message.error(formatMessage(text.error.imageType));
    }
    const isExceed = file.size / 1024 < limitSize;
    if (!isExceed) {
      message.error(formatMessage(text.error.imageSize, { size: limitSize }));
    }

    return isExceed && isPng;
  };

  renderModalTitle = title => (
    <Row className="modal-title-form-builder">{title}</Row>
  );

  renderModalConfirmationStatus = () => {
    const { isChange, isArchive, currentStatus, currentArchive } = this.state;
    const showModal = isChange || isArchive;
    const {
      intl: { formatMessage },
    } = this.props;
    const textConfirmation = isChange ? 'status' : 'archive';
    let btnType = 'change';
    let textStatus = currentStatus;
    if (isArchive) {
      textStatus = currentArchive ? 'archive' : 'restore';
      btnType = currentArchive ? 'archive' : 'restore';
    }

    return (
      showModal && (
        <Modal
          title={this.renderModalTitle(formatMessage(text.confirmation.title))}
          visible={showModal}
          footer={null}
          closable={false}
          className="modal-confirmation"
        >
          <center>
            {formatMessage(text.confirmation[textConfirmation], {
              status: <strong>{textStatus}</strong>,
            })}
          </center>
          <center>
            {isArchive ? formatMessage(text.confirmation.extra.archive) : ''}
          </center>
          <center className="btn-group-change">
            <Button className="btn-cancel" onClick={this.handleCancelStatus}>
              {formatMessage(text.btn.cancel)}
            </Button>
            <Button
              className="btn-change"
              type="primary"
              onClick={this.handleChangeStatus(isArchive)}
            >
              {formatMessage(text.btn[btnType])}
            </Button>
          </center>
        </Modal>
      )
    );
  };

  _handleSyncConsent = isSync => () => {
    this.setState({ syncConsent: isSync }, () => {
      this.props.form.validateFields(this.onValidate);
    });
  };

  renderModalSyncConsent = () => {
    const { syncModalVisible } = this.state;

    return (
      <Modal
        title={this.renderModalTitle('Confirmation')}
        visible={syncModalVisible}
        footer={null}
        closable={false}
        className="modal-confirmation"
      >
        <center>
          Would you like this Service to be available in{' '}
          <b>DANA Global Search?</b>
        </center>
        <center>
          If this Service is still whitelisted, please choose <b>No</b>
        </center>

        <center className="btn-group-change">
          <Button
            className="btn-cancel"
            onClick={this._handleSyncConsent(false)}
          >
            No
          </Button>
          <Button
            className="btn-change"
            type="primary"
            onClick={this._handleSyncConsent(true)}
          >
            Yes
          </Button>
        </center>
      </Modal>
    );
  };

  fileUploadCallback = uploadType => (res, fileInfo, status) => {
    if (status === 'success') {
      message.success({
        content: 'Image Success Upload',
        key: 'imageUpload',
      });
      const fileList = {
        uid: fileInfo.uid,
        name: fileInfo.fileName,
        status: 'done',
        url: res.data.payload.abs_path_url,
      };
      let stateImageList = [];
      if (uploadType.includes('Banner')) {
        const getState = this.state;
        stateImageList = [...getState[uploadType].imageUrl];
        stateImageList.push(fileList);
      }
      this.setState({
        [uploadType]: {
          imageUrl: uploadType.includes('Banner') ? stateImageList : fileList,
          isPreview: false,
          loading: false,
        },
      });
    }
  };

  uploadFile = uploadType => file => {
    this.setState(
      prevState => ({
        [uploadType]: { ...prevState[uploadType], loading: true },
      }),
      () => {
        fileUploaderService(file, this.fileUploadCallback(uploadType));
      },
    );
  };

  invalidCallback = uploadType => () => {
    this.setState(
      prevState => ({
        [uploadType]: {
          ...prevState[uploadType],
          loading: false,
        },
      }),
      () => {
        this.props.form.setFields({
          [uploadType]: {
            file: null,
            fileList: this.state[uploadType].imageUrl,
          },
        });
      },
    );
  };

  handleUploadImage = (info, uploadType) => {
    const maxSize = uploadType.includes('Banner') ? 200 : 100;
    const maxDimension = uploadType.includes('Banner')
      ? { width: 375, height: 96, exact: true }
      : { width: 192, height: 192, exact: true };
    handleUpload(
      { maxSize, maxDimension },
      this.uploadFile(uploadType),
      this.invalidCallback(uploadType),
    )(info);
  };

  renderTitlePreviewBanner = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <center className="preview-title">
        {formatMessage(text.confirmation.preview)}
      </center>
    );
  };

  renderTitleRemoveBanner = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <center className="remove-title">
        {formatMessage(text.confirmation.title)}
      </center>
    );
  };

  renderContentRemoveBanner = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <center className="remove-content">
        {formatMessage(text.confirmation.delete, {
          banner: <strong>banner</strong>,
        })}
      </center>
    );
  };

  handleCancelPreview = () => {
    const { serviceBanner } = this.state;
    this.setState({
      serviceBanner: {
        ...serviceBanner,
        isPreview: false,
      },
    });
  };

  handlePreviewBanner = async file => {
    const { serviceBanner } = this.state;
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      serviceBanner: {
        imageUrl: serviceBanner.imageUrl,
        previewImage: file.url || file.preview,
        isPreview: true,
        selectedImage: file,
      },
    });
  };

  onOkRemoveBanner = file => () => {
    const { serviceBanner } = this.state;
    const currentImageUrl = serviceBanner.imageUrl.filter(
      item => item.uid !== file.uid,
    );
    const errors = currentImageUrl.length
      ? []
      : [new Error('Please upload a banner')];
    this.setState(
      {
        serviceBanner: {
          ...serviceBanner,
          imageUrl: currentImageUrl,
        },
      },
      () => {
        this.props.form.setFields({
          serviceBanner: {
            file: null,
            fileList: currentImageUrl,
            errors,
          },
        });
      },
    );
  };

  handleRemoveBanner = file => {
    this.handleCancelPreview();
    return new Promise(resolve => {
      confirm({
        className: 'remove-banner',
        title: this.renderTitleRemoveBanner(),
        content: this.renderContentRemoveBanner(),
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        cancelButtonProps: 'btn-cancel',
        onOk: this.onOkRemoveBanner(file),
        onCancel: () => {
          resolve(false);
        },
      });
    });
  };

  getBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  renderUploadIcon = () => {
    const { serviceIcon } = this.state;
    const props = {
      name: 'service-icon',
      listType: 'picture-card service-icon',
      className: 'service-icon',
      multiple: false,
      fileList: false,
      showUploadList: false,
      beforeUpload: () => false,
      onChange: info => this.handleUploadImage(info, 'serviceIcon'),
    };

    return (
      <Upload {...props}>
        {serviceIcon.imageUrl.url ? (
          <img src={serviceIcon.imageUrl.url} alt="service-icon" />
        ) : (
          <div>
            <Icon type={serviceIcon.loading ? 'loading' : 'plus'} />
          </div>
        )}
      </Upload>
    );
  };

  renderUploadBanner = () => {
    const { serviceBanner } = this.state;
    const props = {
      name: 'service-banner',
      listType: 'picture-card',
      className: 'service-banner',
      fileList: serviceBanner.imageUrl,
      showUploadList: {
        showPreviewIcon: true,
        showDownloadIcon: false,
        showRemoveIcon: true,
      },
      beforeUpload: () => false,
      onChange: info => this.handleUploadImage(info, 'serviceBanner'),
      onPreview: this.handlePreviewBanner,
      onRemove: this.handleRemoveBanner,
    };

    return (
      <Upload {...props}>
        {serviceBanner.imageUrl.length < 5 ? (
          <div>
            <Icon type={serviceBanner.loading ? 'loading' : 'plus'} />
          </div>
        ) : null}
      </Upload>
    );
  };

  createNewFormElmnt = menu => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="add-on-select">
        {menu}
        <Divider className="divider" />
        <Link to={allBillerRoute.FORM_BUILDERS} className="link-form">
          <div className="dropdown-style" onMouseDown={e => e.preventDefault()}>
            <Icon type="plus" /> {formatMessage(text.createForm)}
          </div>
        </Link>
      </div>
    );
  };

  filterOption = (input, option) =>
    option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  renderBoldLabel = (value = '') => (label = '') => {
    const index = label.toLowerCase().indexOf(value.toLowerCase());
    if (index !== -1) {
      const { length } = value;
      const prefix = label.substring(0, index);
      const suffix = label.substring(index + length);
      const match = label.substring(index, index + length);
      return (
        <span>
          {prefix}
          <span className="search-form">{match}</span>
          {suffix}
        </span>
      );
    }

    return <span>{label}</span>;
  };

  renderLabel = value => item => {
    const publicId = item.public_id;
    let formName = item.name;
    if (value) {
      formName = this.renderBoldLabel(value)(formName);
    }

    return (
      <span>
        {publicId} - {formName}
      </span>
    );
  };

  renderOptions = () =>
    SERVICE_CATEGORIES.map(tag => (
      <Option key={tag.id} value={tag.value}>
        {tag.value}
      </Option>
    ));

  renderServiceId = () => {
    const {
      form: { getFieldDecorator },
      intl: { formatMessage },
      edit,
      service,
    } = this.props;
    return (
      edit && (
        <Form.Item
          required
          colon={false}
          label={formatMessage(text.label.serviceId)}
        >
          {getFieldDecorator('service_id', {
            initialValue: service.public_id,
            rules: [],
          })(
            <Input type="text" disabled className="service-id" size="large" />,
          )}
        </Form.Item>
      )
    );
  };

  renderDivisionId = () => {
    const {
      form: { getFieldDecorator },
      edit,
      service,
    } = this.props;
    return (
      edit && (
        <Form.Item required colon={false} label="Division ID">
          {getFieldDecorator('division_id', {
            initialValue: service.dana_merchant_division_id,
            rules: [],
          })(<Input type="text" disabled size="large" />)}
        </Form.Item>
      )
    );
  };

  renderUniversalKey = () => {
    const {
      form: { getFieldDecorator },
      edit,
      service,
      intl: { formatMessage },
    } = this.props;
    return (
      <>
        <Form.Item
          required
          colon={false}
          label="Universal Keyword"
          extra={
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>
                Universal Keyword are for analytics, mixpanel and other
                integration
              </span>
              <span>
                Universal Keyword are <b>permanent</b> and{' '}
                <b>cannot be changed</b>!
              </span>
            </div>
          }
        >
          {getFieldDecorator('universalKey', {
            initialValue: service.universal_keyword || '',
            getValueFromEvent: ({ target: { value } }) => {
              if (value.length === 1) return value.trim();
              return value;
            },
            rules: [
              {
                required: true,
                message: formatMessage(text.error.universalKey),
              },
              {
                pattern: /^\w+$/g,
                message: formatMessage(text.error.universalKey.pattern),
              },
              {
                max: 30,
                message: formatMessage(text.error.universalKey.length),
              },
            ],
          })(
            <Input
              type="text"
              disabled={!!edit}
              size="large"
              placeholder="Enter Universal Keyword"
            />,
          )}
        </Form.Item>
      </>
    );
  };

  renderArchive = () => {
    const {
      form: { getFieldDecorator },
      intl: { formatMessage },
    } = this.props;
    const { currentArchive } = this.state;
    const initialValue = currentArchive;
    return (
      <Form.Item extra={formatMessage(text.extra.archive)} key="archive">
        {getFieldDecorator('archive', {
          valuePropName: 'checked',
          initialValue,
        })(
          <Checkbox onChange={this.onChangeStatus} name="archive">
            {formatMessage(text.archive)}
          </Checkbox>,
        )}
      </Form.Item>
    );
  };

  renderDate = type => {
    const {
      form: { getFieldDecorator },
      intl: { formatMessage },
    } = this.props;
    const date = type.split('_').join('');
    return (
      <Form.Item
        required
        colon={false}
        label={formatMessage(text.label[date])}
        key={date}
      >
        {getFieldDecorator(type, {
          initialValue: this.props.service[type],
          rules: [],
        })(
          <Input
            type="text"
            disabled
            className={`input-${date}`}
            size="large"
          />,
        )}
      </Form.Item>
    );
  };

  renderEditForm = () => {
    const editForms = [];
    if (checkPermission('Service:update', true)) {
      editForms.push(this.renderArchive());
    }

    editForms.push(this.renderDate('created_at'));
    editForms.push(this.renderDate('updated_at'));
    return editForms;
  };

  renderModalPreviewBanner = () => {
    const { serviceBanner } = this.state;
    const { selectedImage } = serviceBanner;
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Modal
        visible={serviceBanner.isPreview}
        footer={null}
        closable={false}
        title={this.renderTitlePreviewBanner()}
        className="modal-preview-banner"
      >
        <Row>
          <img
            alt="example"
            className="preview-img-banner"
            src={serviceBanner.previewImage}
          />
        </Row>
        <Row className="btn-group-wrapper">
          <center>
            <Button className="btn-cancel" onClick={this.handleCancelPreview}>
              {formatMessage(text.btn.cancel)}
            </Button>
            <Button
              className="btn-delete"
              type="danger"
              onClick={() => this.handleRemoveBanner(selectedImage)}
            >
              {formatMessage(text.btn.delete)}
            </Button>
          </center>
        </Row>
      </Modal>
    );
  };

  customValidation = (_rule, value, callback) => {
    const amount = parseInt(reformatNum(value), 10);
    const {
      intl: { formatMessage },
    } = this.props;

    if (value && amount > 50000) {
      callback(formatMessage(text.error.transactionFee.maxFee));
    } else if (!value) {
      callback(formatMessage(text.error.transactionFee));
    } else {
      callback();
    }
  };

  onSelectOption = node => () => {
    node.blur();
  };

  renderForm = () => {
    const {
      form: { getFieldDecorator },
      // listAggregator,
      listForm,
      intl: { formatMessage },
      edit,
      service,
      loading,
    } = this.props;
    const { currentStatus } = this.state;
    return (
      <Form
        onSubmit={this.handleSubmit}
        layout="vertical"
        className="service-create"
      >
        <Row gutter={24}>
          <Col span={12}>
            {this.renderServiceId()}
            <Form.Item
              required
              colon={false}
              label={formatMessage(text.label.serviceName)}
            >
              {getFieldDecorator('serviceName', {
                initialValue: edit ? service.name : '',
                rules: [
                  {
                    required: true,
                    message: formatMessage(text.error.serviceName),
                  },
                  {
                    max: 30,
                    message: formatMessage(text.error.serviceName.length),
                  },
                ],
              })(
                <Input
                  type="text"
                  className="input-service-name"
                  size="large"
                  placeholder={formatMessage(text.placeholder.serviceName)}
                />,
              )}
            </Form.Item>
            <Form.Item
              colon={false}
              label={formatMessage(text.label.publicServiceName)}
            >
              {getFieldDecorator('publicServiceName', {
                initialValue: edit ? service.public_name : '',
                rules: [
                  {
                    required: true,
                    message: formatMessage(text.error.publicServiceName),
                  },
                  {
                    max: 30,
                    message: formatMessage(text.error.publicServiceName.length),
                  },
                ],
              })(
                <Input
                  type="text"
                  className="input-public-service-name"
                  size="large"
                  placeholder={formatMessage(
                    text.placeholder.publicServiceName,
                  )}
                />,
              )}
            </Form.Item>
            {edit && (
              <Form.Item label="ServiceURL" required colon={false}>
                {getFieldDecorator('service_name_url', {
                  initialValue: get(service, 'page_url', ''),
                })(
                  <TextArea
                    rows={2}
                    disabled
                    style={{ resize: 'none', padding: '10px' }}
                  />,
                )}
              </Form.Item>
            )}
            <Form.Item
              required
              colon={false}
              label={formatMessage(text.label.serviceIcon)}
              extra={formatMessage(text.extra.serviceIcon)}
            >
              {getFieldDecorator('serviceIcon', {
                initialValue: this.state.serviceIcon.imageUrl,
                rules: [
                  {
                    required: true,
                    message: formatMessage(text.error.serviceIcon),
                  },
                ],
              })(this.renderUploadIcon())}
            </Form.Item>
            {edit && (
              <Form.Item label="IconURL" required colon={false}>
                {getFieldDecorator('service_icon_url', {
                  initialValue: service.icon_abs_url,
                })(
                  <TextArea
                    rows={2}
                    disabled
                    style={{ resize: 'none', padding: '10px' }}
                  />,
                )}
              </Form.Item>
            )}
            <Form.Item
              required
              colon={false}
              label={formatMessage(text.label.serviceBanner)}
              extra={formatMessage(text.extra.serviceBanner)}
            >
              {getFieldDecorator('serviceBanner', {
                initialValue: this.state.serviceBanner.imageUrl,
                rules: [
                  {
                    required: true,
                    message: formatMessage(text.error.serviceBanner),
                  },
                ],
              })(this.renderUploadBanner())}
            </Form.Item>
            {this.renderUniversalKey()}
            <Form.Item
              colon={false}
              label="Beneficiary Account Holder Name Masking"
              extra="This will affect masking on H5 confirmation page. e.g. Chr•••• Sm••• "
            >
              {getFieldDecorator('maskFullName', {
                initialValue: get(
                  service,
                  'should_mask_beneficiary_full_name',
                  true,
                )
                  ? 'yes'
                  : 'no',
              })(
                <Radio.Group>
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no">No</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
            <Form.Item colon={false} label={formatMessage(text.label.status)}>
              {getFieldDecorator('status', {
                initialValue:
                  edit && service.is_active ? 'active' : currentStatus,
                rules: [],
              })(
                <Radio.Group
                  onChange={this.onChangeStatus}
                  id="radio-status"
                  name="status"
                >
                  <Radio value="inactive">
                    {formatMessage(text.status.inactive)}
                  </Radio>
                  <Radio value="active">
                    {formatMessage(text.status.active)}
                  </Radio>
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              required
              colon={false}
              label={formatMessage(text.label.defaultForm)}
            >
              {getFieldDecorator('form', {
                initialValue:
                  edit && service.default_form
                    ? service.default_form.form_id
                    : undefined,
                rules: [
                  {
                    required: true,
                    message: formatMessage(text.error.defaultForm),
                  },
                ],
              })(
                <Select
                  showSearch
                  size="large"
                  className="search-default-form"
                  placeholder={formatMessage(text.placeholder.defaultForm)}
                  suffixIcon={<Icon type="search" />}
                  notFoundContent={null}
                  dropdownRender={this.createNewFormElmnt}
                  onSearch={this.handleSearch('form')}
                  onFocus={() => {
                    this.handleSearch('')('form');
                  }}
                  filterOption={this.filterOption}
                  onSelect={this.onSelectOption(this.selectFormRef.current)}
                  ref={this.selectFormRef}
                >
                  {listForm.map(form => (
                    <Option
                      key={form.id}
                      value={form.id}
                      label={`${form.public_id} - ${form.name}`}
                    >
                      {/* {this.renderLabel(form)(this.state.searchForm)} */}
                      {this.renderLabel(this.state.searchForm)(form)}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
            <Form.Item
              // required
              colon={false}
              label={formatMessage(text.label.aggregator)}
            >
              {getFieldDecorator('aggregator', {
                initialValue: 'DANA X2X',
                rules: [
                  {
                    required: false,
                    message: formatMessage(text.error.aggregator),
                  },
                ],
              })(
                <Select
                  // showSearch
                  size="large"
                  className="search-aggregator"
                  placeholder={formatMessage(text.placeholder.aggregator)}
                  // suffixIcon={<Icon type="search" />}
                  // onSearch={this.handleSearchAggregator}
                  // onChange={this.handleChange}
                  disabled
                >
                  <Option value="DANA X2X">DANA X2X</Option>
                  {/* {listAggregator.map(aggr => (
                    <Option key={aggr.aggregator_id} value={aggr.name}>
                      {aggr.aggregator_id} - {aggr.name}
                    </Option>
                  ))} */}
                </Select>,
              )}
            </Form.Item>
            <Form.Item
              required
              colon={false}
              label={formatMessage(text.label.serviceCategory)}
            >
              {getFieldDecorator('serviceCategory', {
                initialValue: edit ? service.category : undefined,
                rules: [
                  {
                    required: true,
                    message: formatMessage(text.error.serviceCategory),
                  },
                ],
              })(
                <Select
                  size="large"
                  placeholder={formatMessage(text.placeholder.serviceCategory)}
                  className="select-service-category"
                >
                  {this.renderOptions()}
                </Select>,
              )}
            </Form.Item>

            <Form.Item
              required
              colon={false}
              label={formatMessage(text.label.transactionFee)}
              extra="Transaction fee configuration per biller is available in create or update biller page"
            >
              {getFieldDecorator('transactionFee', {
                getValueFromEvent: amountInput,
                initialValue: edit
                  ? formatMoney(get(service, 'transaction_fee', '0'))
                  : '',
                rules: [
                  {
                    validator: this.customValidation,
                  },
                ],
              })(
                <Input
                  placeholder={formatMessage(text.placeholder.transactionFee)}
                  size="large"
                />,
              )}
            </Form.Item>
            {edit ? this.renderEditForm() : null}
          </Col>
        </Row>
        <Row>
          <Button
            type="primary"
            htmlType="submit"
            className="btn btn-submit-service"
            loading={loading}
          >
            {formatMessage(text.btn.save)}
          </Button>
          <Button
            type="default"
            className="btn btn-cancel-service"
            onClick={this.handleCancel}
          >
            {formatMessage(text.btn.cancel)}
          </Button>
          <span className="info-field">
            {formatMessage(text.mandatoryField)}
          </span>
        </Row>
        {this.renderModalPreviewBanner()}
      </Form>
    );
  };

  onSubmitMaintenanceModal = value => {
    const { setRemarksInactive, form } = this.props;

    this.setState(
      {
        remarksInactiveData: value,
        isChange: false,
        isArchive: false,
      },
      () => {
        if (this.state.fromArchive) {
          form.validateFields(this.onValidate);
        }
      },
    );
    setRemarksInactive(false);
  };

  renderMaintenanceModal = () => {
    const {
      remarksInactive,
      intl: { formatMessage },
    } = this.props;

    const { remarksInactiveData } = this.state;

    return (
      remarksInactive && (
        <Modal
          title={this.renderModalTitle(
            formatMessage(text.confirmation.maintenanceTitle),
          )}
          visible={remarksInactive}
          footer={null}
          closable={false}
        >
          <FormMaintenanceRemarks
            submitMaintenance={this.onSubmitMaintenanceModal}
            cancelMaintenance={this.handleCancelStatus}
            previousData={remarksInactiveData}
          />
        </Modal>
      )
    );
  };

  render() {
    return (
      <div>
        {this.renderForm()}
        {this.renderModalConfirmationStatus()}
        {this.renderModalSyncConsent()}
        {this.renderMaintenanceModal()}
      </div>
    );
  }
}

ServiceForm.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  history: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  service: PropTypes.object,
  getListAggregator: PropTypes.func,
  listAggregator: PropTypes.array,
  getListForm: PropTypes.func,
  listForm: PropTypes.array,
  edit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  loading: PropTypes.bool,
  setRemarksInactive: PropTypes.func,
  remarksInactive: PropTypes.bool,
};

export default withRouter(ServiceForm);
